module.exports = __webpack_public_path__ + "c2234c8ef6e427f6ba41974f39c7df3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/integration.png
// module id = 59
// module chunks = 0